import { globalCssToken as o } from "./utils.mjs";
const e = {
  dimension: {
    gap: o("dimension", "gap")
  },
  color: {
    text: {
      default: o("color", ["text", "default"]),
      accent: o("color", ["text", "accent"])
    }
  }
};
export {
  e as C
};
